import { JsonFormPropertyV2, RequireWhenRule } from './types'
import { evaluateRule } from './utils'

export function isFieldVisible(
  property: JsonFormPropertyV2,
  data: Record<string, unknown>,
  visibleWhenMatchedIds?: Set<string>
): boolean {
  if (property.visible === false) return false
  if (property.visibleWhen) {
    if (visibleWhenMatchedIds) return visibleWhenMatchedIds.has(property.id)
    return evaluateRule(data, property.visibleWhen)
  }
  return true
}

export function filterVisibleProperties(
  properties: JsonFormPropertyV2[],
  data: Record<string, unknown>,
  visibleWhenMatchedIds?: Set<string>
): JsonFormPropertyV2[] {
  return properties.filter((property) => isFieldVisible(property, data, visibleWhenMatchedIds))
}
